import { combineReducers } from 'redux';
import registration from 'products/global/views/Ambassador/Registration/state';
import dashboard from 'products/global/views/Ambassador/Dashboard/state';
import update from 'products/global/views/Ambassador/Update/state';
import signup from 'products/global/views/Ambassador/Signup/state';
import ambassadorUser from './ambassador';

const ambasssadorReducer = combineReducers({
  ambassadorUser,
  dashboard,
  registration,
  update,
  signup
});

export default ambasssadorReducer;
